import React, { useEffect, useState } from 'react';
import espectacularICF from '../../assets/images/productos/anuncio/D2.png';


const IlustracionPR = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Efecto de aparición al montar el componente
    const timer = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (  
    <div className="flex justify-center items-center w-full py-8">
      <img
        src={espectacularICF}
        alt="Imagen principal Campo Fresco"
        className={`max-w-full h-auto rounded-2xl shadow-2xl transition-all duration-1000 ease-out
          ${show ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}
        style={{ maxHeight: '100%', objectFit: 'contain' }}
      />
    </div>
  );
};

export default IlustracionPR;
